"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const bit_utils_context_1 = require("@gcloud-npm/bit.utils.context");
const react_helmet_1 = require("react-helmet");
/* que este se subscriba a seo y escriba verdad? */
class MetaData extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            seoInfo: null,
        };
        this.componentDidMount = () => {
            const { projectId, seoCustomValue, pageId, pageWithExtraInfo } = this.props;
            const aliasFront = seoCustomValue || '{}';
            const { segment } = this.props;
            const reqData = {
                SEG_NAV: segment,
                location: `${pageId}`,
                customValues: aliasFront,
            };
            // preguntamos a context
            const match = this.props.match || null;
            const params = (match && match.params) || null;
            if (pageWithExtraInfo && match && params) {
                let myUrl = reqData.location;
                const paramsKeys = Object.keys(params);
                paramsKeys.forEach((key) => {
                    const value = params[key];
                    myUrl = myUrl.replace(`:${key}`, value);
                });
                reqData.location = myUrl;
            }
            window.nookInfoExchange.sendMessage('SEO_PARAMS', reqData);
            // respuesta de context
            window.nookInfoExchange.registerAsObserver(bit_utils_context_1.QUEUE_NAMES.SEO_DATA, `${projectId}-SEO`, (seoData) => {
                window.nookInfoExchange.cleanObserver(bit_utils_context_1.QUEUE_NAMES.SEO_DATA, `${projectId}-SEO`);
                this.setState({ seoInfo: seoData });
                this.props.onFinish(seoData);
            });
        };
    }
    render() {
        const { seoInfo } = this.state;
        if (!seoInfo) {
            return null;
        }
        const seoInfoKeys = seoInfo ? Object.keys(seoInfo) : [];
        if (seoInfoKeys.length === 0) {
            return null;
        }
        /* eslint-disable camelcase */
        const { 
        /* basics first level values */
        title, description, keywords, robots, canonical, } = seoInfo;
        /* modifications dates */
        const { dateModified, datePublished, dateCreated } = seoInfo;
        /* rrss_fb */
        const { rrss_fb } = seoInfo;
        const fbTitle = rrss_fb && rrss_fb['og:title'] ? rrss_fb['og:title'] : '';
        const fbType = rrss_fb && rrss_fb['og:type'] ? rrss_fb['og:type'] : '';
        const fbImage = rrss_fb && rrss_fb['og:image'] ? rrss_fb['og:image'] : '';
        const fbUrl = rrss_fb && rrss_fb['og:url'] ? rrss_fb['og:url'] : '';
        const fbDescription = rrss_fb && rrss_fb['og:description'] ? rrss_fb['og:description'] : '';
        const fbSiteName = rrss_fb && rrss_fb.site_name ? rrss_fb.site_name : '';
        /* x aki vamos */
        const { search_engines_verification } = seoInfo;
        /* microdata */
        const { microdata_product, microdata_website, breadcrums } = seoInfo;
        return (react_1.default.createElement(react_helmet_1.Helmet, null,
            title && react_1.default.createElement("title", null, title),
            description && react_1.default.createElement("meta", { name: "description", content: description }),
            keywords && react_1.default.createElement("meta", { name: "keywords", content: keywords }),
            robots && react_1.default.createElement("meta", { name: "Robots", content: robots }),
            canonical && react_1.default.createElement("link", { rel: "canonical", href: canonical }),
            react_1.default.createElement("meta", { name: "author", content: "Movistar" }),
            react_1.default.createElement("meta", { name: "owner", content: "Movistar" }),
            dateModified && (react_1.default.createElement("meta", { itemProp: "dateModified", content: dateModified })),
            datePublished && (react_1.default.createElement("meta", { itemProp: "datePublished", content: datePublished })),
            dateCreated && react_1.default.createElement("meta", { itemProp: "dateCreated", content: dateCreated }),
            fbTitle && react_1.default.createElement("meta", { property: "og:title", content: fbTitle }),
            fbImage && react_1.default.createElement("meta", { property: "og:image", content: fbImage }),
            fbType && react_1.default.createElement("meta", { property: "og:type", content: fbType }),
            fbUrl && react_1.default.createElement("meta", { property: "og:url", content: fbUrl }),
            fbDescription && (react_1.default.createElement("meta", { property: "og:description", content: fbDescription })),
            fbSiteName && react_1.default.createElement("meta", { property: "og:site_name", content: "Movistar" }),
            search_engines_verification &&
                search_engines_verification.length > 0 &&
                search_engines_verification.map((item) => {
                    const keyName = Object.keys(item)[0] || '';
                    const value = item[keyName] || '';
                    return (react_1.default.createElement("meta", { key: `${keyName}-${value}`, name: keyName, content: value }));
                }),
            microdata_product && (react_1.default.createElement("script", { type: "application/ld+json" }, JSON.stringify(microdata_product))),
            microdata_website && (react_1.default.createElement("script", { type: "application/ld+json" }, JSON.stringify(microdata_website))),
            breadcrums && (react_1.default.createElement("script", { type: "application/ld+json" }, JSON.stringify(breadcrums)))));
    }
}
exports.default = MetaData;
//# sourceMappingURL=MetaData.js.map